export enum DetailsActionDialogs {
  ReviewerSettings = 'REVIEWER_SETTINGS',
}
